import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { selectApiUrl } from "utils/State";

export const dynamicBaseQuery = () => {
    return async (args, api, extraOptions) => {
        const baseUrl = selectApiUrl(api.getState());
        const baseQuery = fetchBaseQuery({ baseUrl });
        return baseQuery(args, api, extraOptions);
    };
};